/**
 * Member contact list (membermanagement 003).
 * Mirrors backend/Libraries/CCMSLib.Models/Members/MemberContactLookups.cs and
 * ModelView/MemberContactPointViews.cs.
 *
 * A member has several phone numbers and email addresses. Each has a label (Mobile, Home, Work, Other)
 * and the uses it is for (Calling, WhatsApp, SMS for phones; Email for emails), with at most ONE main
 * (primary) per use. The legacy member columns stay in step: `cellNumber` is the main Calling number and
 * `email` the main email address.
 */
/** Fixed ids of the seeded lookups (MemberContactKind, MemberContactLabel, MemberContactUse). */
export const MemberContactIds = {
    KindPhone: 1,
    KindEmail: 2,
    LabelMobile: 1,
    LabelHome: 2,
    LabelWork: 3,
    LabelOther: 4,
    UseCalling: 1,
    UseWhatsApp: 2,
    UseSms: 3,
    UseEmail: 4,
};
//# sourceMappingURL=MemberContactPoint.js.map